import React from "react";
import EnquiriesList from "./../enquiries/EnquiriesList";
import { useSelector } from "react-redux";
import PromotionBanner from "./banner/banner";
import {
  isBuyer,
  isCustomhouseagentsCumFreightforwarder,
  isExporter,
  isManufacturerCumExporter,
} from "./../../util/helper";
import VerificationBanner from "./setup/VerificationBanner";
import RFQList from "../requestQuotation/RFQList";
import StaticBanner from "./banner/StaticBanner";
import AdminPromotions from "./banner/AdminPromotions";
import AdminPromotionTypeOne from "./banner/AdminPromotionTypeOne";
import AdminPromotionTypeTwo from "./banner/AdminPromotionTypeTwo";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { Col, Row } from "antd";
import { BUSINESS_TYPE } from "../../util/Constant";
import GetFreightRateQuotationsList from "../requestFreightRates/GetFreightRateQuotationsLists";
import ChaQuotationsList from "../requestCha/ChaQuotationsList";
import ManufacturerRFQList from "../sourceYourCargo/ManufacturerRFQList";
import BuyerOfferProductsList from "../cargoOffersBuyer/BuyerOfferProductsList";
import AdminToBuyerOfferProductList from "../cargoOfferAdminToBuyer/AdminToBuyerOfferProductList";

const Home = () => {
  const userData = useSelector(({ auth }) => auth?.userData);
  const { isMobile } = useGetBreakpoints();
  return (
    <>
      {/*<Setup />*/}
      {/* {userData?.status !== "approved" && (
        <VerificationBanner showButton={true} />
      )} */}
      {/* <StaticBanner/> */}
      {/* <PromotionBanner /> */}
      <AdminPromotions />
      {/* {isBuyer(userData) && <RFQList />} */}
      {/* {isBuyer(userData) && <BuyerOfferProductsList/>} */}
      {isBuyer(userData) && <AdminToBuyerOfferProductList/>}
      {!isBuyer(userData) && !isExporter(userData) && (
        <>
         
          {isCustomhouseagentsCumFreightforwarder(userData) && (
            <>
              {/* Freight Forwarder Leads */}
              <EnquiriesList
                fromDashboard={true}
                defaultRole={BUSINESS_TYPE.FREIGHT_FORWARDER}
              />
              
             
              <EnquiriesList
                fromDashboard={true}
                defaultRole={BUSINESS_TYPE.CUSTOM_HOUSE_AGENT}
              />
            </>
          )}
          
          
          {!isCustomhouseagentsCumFreightforwarder(userData) && (
            <EnquiriesList
              fromDashboard={true}
              defaultRole={
                isManufacturerCumExporter(userData)
                  ? BUSINESS_TYPE.BUYER
                  : undefined
              }
            />
          )}
        </>
      )}
      {(isExporter(userData) || isManufacturerCumExporter(userData)) && (
        <GetFreightRateQuotationsList fromDashboard={true} />
      )}
      {(isExporter(userData)) && (
        <ManufacturerRFQList fromDashboard={true} />
      )}
      {(isExporter(userData) || isManufacturerCumExporter(userData)) && (
        <ChaQuotationsList fromDashboard={true}/>
      )}

      {!isMobile ? (
        <div>
          <Row gutter={16}>
            <Col span={12}>
              <AdminPromotionTypeOne />
            </Col>
            <Col span={12}>
              <AdminPromotionTypeTwo />
            </Col>
          </Row>
        </div>
      ) : (
        <div className="promotion-banners-column">
          <AdminPromotionTypeOne />
          <AdminPromotionTypeTwo />
        </div>
      )}
    </>
  );
};

export default Home;